import React from 'react';

const AdminCrumb = () => <p>Administration</p>;

export default AdminCrumb;
